import { IArtistsListFilter, RequestPagerI } from '@tacans/shared-marketplace-layer';

export enum EArtistSortBy {
    LATEST = 'latest',
    OLDEST = 'oldest',
    NAME_ASC = 'name_asc',
    NAME_DESC = 'name_desc',
}

export interface IFetchArtistParams {
    sort?: EArtistSortBy,
    filter: IArtistsListFilter,
    pager?: RequestPagerI,
}